import React, { useState } from 'react'

export const ShowComment = ({setShowComment, statusComment, order,handlePushComment}) => {
    const [comment, setComment] = useState('');

     const handleClosecomment = (e) => {
    e.stopPropagation();
    setShowComment(false);
  };
  return (
   <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000073] z-50 " onClick={handleClosecomment} >
         <div className="flex flex-col content-center items-center w-[600px] m-auto my-[5%] bg-white rounded-lg py-[15px] px-[15px]">
          
           <div className="text-center text-xl text-[#979797] font-rubik font-bold">
            {order}
           </div>
           <div className="text-center text-2xl border border-[#D9D9D9] h-[200px] w-[90%] overflow-y-auto rounded-lg bg-white">
            {statusComment?.map((item, index) => (
                <div key={index} className="text-left p-2 border-b border-gray-200">
                    <p className="text-sm text-gray-800">{item}</p>
                </div>
            ))}
           </div>

           <input type="text" 
              className=" h-[40px] w-[90%] px-2 m-2 border-solid border-[1px] border-[#D9D9D9] outline-none rounded-[10px]  "
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            onClick={(e) => e.stopPropagation()}
           />

           <button className="w-[60px] h-[30px] rounded-lg  border-[1px] border-[#D9D9D9]"
           onClick={(e) => handlePushComment(e, comment)}>
            Save
           </button>
         </div>
       </div>
  )
}
